module.exports = __webpack_public_path__ + "static/media/21.fd1c6882.jpg";